import type { IconNode } from '../types';

/**
 * @name bottle-baby
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjAgMTFjMS4xLTEuNCAxLjMtMy4zLjctNC45bC44LS44YTEuNSAxLjUgMCAwIDAtMi44LTIuOGwtLjguOEE1LjMzIDUuMzMgMCAwIDAgMTMgNCIgLz4KICA8cGF0aCBkPSJNMTEuMyAzLjdhMSAxIDAgMCAxIDEuNCAwbDcuNiA3LjZhMSAxIDAgMCAxIDAgMS40bC0xLjYgMS42YTEgMSAwIDAgMS0xLjQgMEw5LjcgNi43YTEgMSAwIDAgMSAwLTEuNFoiIC8+CiAgPHBhdGggZD0ibTEwIDctNy4zIDcuM2MtLjkuOS0uOSAyLjUgMCAzLjRsMy42IDMuNmMuOS45IDIuNS45IDMuNCAwTDE3IDE0IiAvPgogIDxwYXRoIGQ9Im00IDEzIDIgMiIgLz4KICA8cGF0aCBkPSJtNyAxMCAyIDIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/bottle-baby
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const bottleBaby: IconNode = [
  [
    'path',
    {
      d: 'M20 11c1.1-1.4 1.3-3.3.7-4.9l.8-.8a1.5 1.5 0 0 0-2.8-2.8l-.8.8A5.33 5.33 0 0 0 13 4',
      key: '1iy6os',
    },
  ],
  [
    'path',
    {
      d: 'M11.3 3.7a1 1 0 0 1 1.4 0l7.6 7.6a1 1 0 0 1 0 1.4l-1.6 1.6a1 1 0 0 1-1.4 0L9.7 6.7a1 1 0 0 1 0-1.4Z',
      key: '15dvlp',
    },
  ],
  ['path', { d: 'm10 7-7.3 7.3c-.9.9-.9 2.5 0 3.4l3.6 3.6c.9.9 2.5.9 3.4 0L17 14', key: '4h4t1r' }],
  ['path', { d: 'm4 13 2 2', key: 'cag95t' }],
  ['path', { d: 'm7 10 2 2', key: '1w0xrs' }],
];

export default bottleBaby;
